import { messageFormatOf } from "./message-format.js";
import phrases from "./catalog/errors.en.json";
import { portalLocale, portalText, type PortalKey, type PortalValues } from "./portal.js";

interface MessagePattern {
  readonly key: PortalKey<"errors">;
  readonly expression: RegExp;
  readonly variables: readonly string[];
  readonly fixedLength: number;
}

/** Match authoritative API error formats, preserving every variable from the original refusal. */
function patternOf(key: string, phrase: string): MessagePattern {
  return { key: key as PortalKey<"errors">, ...messageFormatOf(phrase) };
}

const PATTERN = Object.entries(phrases).map(([key, phrase]) => patternOf(key, phrase))
  .sort((left, right) => right.fixedLength - left.fixedLength);

export function translatedApiMessage(message: string): string | null {
  if (portalLocale() === "en") return message;
  for (const pattern of PATTERN) {
    const matched = pattern.expression.exec(message);
    if (matched === null) continue;
    const values: Record<string, string> = {};
    pattern.variables.forEach((name, index) => { values[name] = matched[index + 1]!; });
    return portalText("errors", pattern.key, values as PortalValues);
  }
  return null;
}
